<template>
  <div id="box">
    <div>
      <div class="container header" style="padding-top: 20px;">
        <div id="logo">
          <img src="/img/goin/logo_03.png" alt="" />

        </div>
        <!-- 汉堡按钮 -->
        <div class="hamburger" @click="toggleMenu" v-show="isMobile">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
        <!-- 导航菜单 -->
        <nav class="nav" :class="{ open: menuOpen }">
          <ul>
            <li><router-link to="/" @click.native="closeMenu" :class="{ active: $route.path === '/' }">首页</router-link></li>
            <li><router-link to="/goin" @click.native="closeMenu" :class="{ active: $route.path === '/goin' }">走进企业</router-link></li>
            <li><router-link to="/products" @click.native="closeMenu" :class="{ active: $route.path === '/products' }">匠心产品</router-link></li>
            <li><router-link to="/innovation" @click.native="closeMenu" :class="{ active: $route.path === '/innovation' }">品质创新</router-link></li>

            <li><router-link to="/business" @click.native="closeMenu" :class="{ active: $route.path === '/business' }">业务概况</router-link></li>
            <li><router-link to="/news" @click.native="closeMenu" :class="{ active: $route.path === '/news' }">新闻动态</router-link></li>
            <li><router-link to="/contact" @click.native="closeMenu" :class="{ active: $route.path === '/contact' }">联系我们</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      menuOpen: false,
      isMobile: false
    };
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  mounted() {},
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.menuOpen = false;
      }
    }
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: clamp(4px, 1vw, 10px) 0;
  background-color: #f4f4f4;
  position: relative;
  z-index: 10;
  color: #333;
}
.nav{
    width: 53%;
}
.nav ul{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    font-size: clamp(14px, 1.6vw, 18px);
}

#logo img{
    width: 100%;
    height: 50px;
}

/* 汉堡按钮样式 */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}

.hamburger .bar {
  width: 30px;
  height: 3px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #E5E4DF;
    transform: translateX(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 5;
    padding-top: 60px;
  }
  
  .nav.open {
    transform: translateX(0);
    opacity: 1;
    visibility: visible;
  }
  
  .nav ul {
    flex-direction: column;
    padding: clamp(15px, 3vw, 20px) 0;
    font-size: clamp(14px, 4vw, 18px);
  }
  
  .nav ul li {
    margin: 15px 0;
    text-align: center;
  }
  
  .nav ul li a {
    display: block;
    padding: 10px 20px;
    color: #333;
    text-decoration: none;
  }
  
  .nav ul li a:hover {
    background: rgba(0,0,0,0.05);
  }
}
.nav ul li a.active {
    font-weight: bold;
  }
</style>